(() => {
  if (window.acqSoundReset) return;
  window.acqSoundReset = true;

  const TOGGLE_SELECTOR = ".wt-hero-video__sound-toggle";
  const UNMUTED_CLASS = "wt-hero-video__sound-toggle--unmuted";

  const findToggle = (video) => {
    const wrapper = video.closest("[data-acq-sound-reset]");
    return wrapper ? wrapper.querySelector(TOGGLE_SELECTOR) : null;
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting || video.muted) return;
        video.muted = true;
        const toggle = findToggle(video);
        if (toggle) toggle.classList.remove(UNMUTED_CLASS);
      });
    },
    { threshold: 0 }
  );

  const observed = new WeakSet();

  // volumechange does not bubble, so listen in the capture phase
  document.addEventListener(
    "volumechange",
    (event) => {
      const video = event.target;
      if (!(video instanceof HTMLVideoElement)) return;
      if (video.muted || observed.has(video)) return;
      if (!video.closest("[data-acq-sound-reset]")) return;
      observed.add(video);
      observer.observe(video);
    },
    true
  );
})();
